import React, { Component } from 'react';

import {ResponsiveContainer, XAxis, YAxis, CartesianGrid, Tooltip, Legend, BarChart, Rectangle, Bar} from 'recharts';
import StatisticService from '../services/StatisticService';

class ReportBar extends Component {
  constructor() {
    super();
    this.state = {
      data: []
    }
  }

  componentDidMount () { 
    this.loadData();
  }

  loadData() {
    StatisticService.getGhiLoiStatistics().then(data => {
      if (data !== undefined && data !== null && data instanceof Array) {
        this.setState({ data: data })
      }
    });
  }

  render() {
    const { data } = this.state;
    return (
      <ResponsiveContainer width="70%" aspect={3}>
        <BarChart
          width={200}
          height={300}
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="count" fill="#8884d8" activeBar={<Rectangle fill="pink" stroke="blue" />} />
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

export default ReportBar;
